var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dividerTitle"},[_vm._m(0),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.text))]),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"flex":"1","display":"-webkit-flex","flex-direction":"row"}},[_c('div',{staticClass:"divider"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"flex":"1","display":"-webkit-flex","flex-direction":"row"}},[_c('div',{staticClass:"divider"})])
}]

export { render, staticRenderFns }